import React from "react"

import Layout from "../../layout/Layout"

import { Container, Row, Col } from "react-bootstrap"
import TitleBoldLarge from "../../components/typography/TitleBoldLarge"
import TitleLight from "../../components/typography/TitleLight"
import HelmetInject from "../../components/HelmetInject"

import ImageComplete from "../../layout/parts/ImageComplete.js"
import vaccineLogo from "../../images/vaccine.svg"

export default function CoronavirusVaccine() {
  return (
    <>
      <HelmetInject
        title="Corona News"
        contentDescription="Corona News of the COVID - 19 Vaccine Tracker"
      />
      <Layout>
        <Container fluid className="background-color-white mb-5">
          <Row>
            <Col className="text-center">
              <h1 className="mt-5">
                <TitleBoldLarge>The most important Corona News</TitleBoldLarge>
              </h1>
            </Col>
          </Row>
          <Row>
            <Col className="text-center">
              <h2 className="mt-5">
                <TitleLight>Get the last important Corona News</TitleLight>
              </h2>
              <h2 className="mt-5">AstraZeneca Halts Vaccine Developing</h2>
            </Col>
          </Row>
        </Container>
        <Container className="background-color-white">
          <Row>
            <Col className="text-center mt-3">
              <ImageComplete
                alt={"Corona News - Astrazeneca vaccine halted"}
                src={vaccineLogo}
                className="img-fluid"
                width="400"
                height="400"
              />
            </Col>
          </Row>
          <Row>
            <Col className="text-center mt-3">
              In the most importants <b>corona news</b> of the day appear the
              Astrazeneca Vaccine new : The company stopped late-stage trials of
              its coronavirus vaccine due to a participant developing a
              significant potential adverse reaction.
            </Col>
          </Row>
          <Row>
            <Col className="text-center mt-3">
              The organization said it was "attempting to speed up the survey of
              the single occasion to limit any possible effect on the
              preliminary timetable," and reaffirmed its responsibility "to the
              security of our members and the best expectations of direct in our
              preliminaries."
              <b>This Ends the Corona news</b>
            </Col>{" "}
          </Row>
        </Container>
      </Layout>
    </>
  )
}
